/**
 * Filter Chips Component
 * 
 * Active filter tags display
 * 
 * Version: 6.2.0
 */
import React, { ReactNode } from 'react'
import './FilterChips.css'

interface FilterChip {
  id: string
  label: string
  icon?: ReactNode
  color?: string
}

interface FilterChipsProps {
  chips: FilterChip[]
  onRemove: (id: string) => void
  onClearAll?: () => void
  label?: string
  className?: string
}

const FilterChips: React.FC<FilterChipsProps> = ({
  chips,
  onRemove,
  onClearAll,
  label = 'Active Filters',
  className = ''
}) => {
  if (chips.length === 0) return null

  return (
    <div className={`filter-chips-container ${className}`}>
      {label && (
        <span className="filter-chips-label">{label}</span>
      )}
      
      <div className="filter-chips-list">
        {chips.map((chip) => (
          <div 
            key={chip.id} 
            className="filter-chip"
            style={chip.color ? { '--chip-color': chip.color } as React.CSSProperties : undefined}
          >
            {chip.icon && <span className="chip-icon">{chip.icon}</span>}
            <span className="chip-label">{chip.label}</span>
            <button 
              className="chip-remove"
              onClick={() => onRemove(chip.id)}
              aria-label={`Remove ${chip.label}`}
            >
              ✕
            </button>
          </div>
        ))}
        
        {onClearAll && chips.length > 1 && (
          <button className="filter-clear-all" onClick={onClearAll}>
            Clear All
          </button>
        )}
      </div>
    </div>
  )
}

export default FilterChips